var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BRow',[_c('BCol',{attrs:{"cols":"12"}},[_c('div',{staticClass:"mb-3 p-4 bg-light rounded-custom"},[_c('BRow',[_c('InfoForAudio')],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }